// extracted by mini-css-extract-plugin
export default {"grid":"ProfilePreferences-module__grid","container":"ProfilePreferences-module__container"};